interface SchemaOrgMetatags {
  schemaOrgMetatags?: {
    json?: string | null
  } | null
}

export default function (metatags?: MaybeRef<unknown>) {
  const value = toValue(metatags) as SchemaOrgMetatags | undefined | null

  if (!value?.schemaOrgMetatags?.json) {
    return
  }

  useHead({
    script: [
      {
        type: 'application/ld+json',
        innerHTML: value.schemaOrgMetatags.json,
      },
    ],
  })
}
